import { Clipboard } from '@angular/cdk/clipboard';
import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { I18NextPipe } from 'angular-i18next';
import { CopyButtonComponent } from '../copy-button/copy-button.component';
import { TextEllipsisAppendDirective, TextEllipsisComponent } from '../text-ellipsis';
import { ToastService } from '../toast';

@Component({
  selector: 'mbs-clipboard',
  templateUrl: './clipboard.component.html',
  imports: [TextEllipsisAppendDirective, TextEllipsisComponent, CopyButtonComponent],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ClipboardComponent {
  private readonly clipboard = inject(Clipboard);
  private readonly i18n = inject(I18NextPipe);
  private readonly toastService = inject(ToastService);

  public readonly content = input.required<string>();
  public readonly contentToCopy = input<string | null>(null);

  protected readonly toCopy = computed<string>(() => this.contentToCopy() ?? this.content());

  handleCopy(): void {
    this.clipboard.copy(this.toCopy());
    this.toastService.success(this.i18n.transform('shared:toasts.successfullyCopied'));
  }
}
